import React from "react";
import { withStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  DialogActions,
  Button,
  IconButton,
} from "@material-ui/core";

const styles = (theme) => ({
  dialog: {
    padding: "18px 24px",
    boxSizing: "border-box",
    borderRadius: "2px",
    backgroundColor: theme.ModalBGColor,
    boxShadow: "2px 2px 4px black",
    width: 400,
    userSelect: "none",
  },
  dialogTitle: {
    fontSize: theme.headerTextFontSize,
    fontWeight: "600",
    lineHeight: "20px",
    color: "#D03131",
    padding: 0,
  },
  dialogContent: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    overflow: "hidden",
    padding: "16px 0px",
  },
  redButton: {
    fontSize: theme.headerTextFontSize,
    textTransform: "none",
    borderRadius: "2px",
    margin: 0,
    width: "47%",
    background: "#D03131",
    color: theme.ModalBGColor,
  },
  button: {
    fontSize: theme.headerTextFontSize,
    textTransform: "none",
    borderRadius: "2px",
    margin: 0,
    width: "47%",
  },
  dialogAction: {
    justifyContent: "space-between",
    margin: 0,
    "&$actionButton": {
      paddingBottom: 0,
      paddingRight: 0,
    },
  },
  actionButton: {
    margin: 0,
    padding: 0,
    display: "flex",
    justifyContent: "space-between",
  },
  closeButton: { color: theme.iconColor, padding: "0px 10px" },
  dialogTitlestyle: {
    padding: 0,
    height: "20px",
  },
});

const DeleteAnchorPoint = (props) => {
  const { classes, selectedAnchorPoints } = props;
  const errorMessage =
    selectedAnchorPoints.length > 1
      ? `Are you sure you want to delete selected anchor points ${selectedAnchorPoints
          ?.map((anchorPoint) => {
            return anchorPoint.anchorPointName;
          })
          .join(",")} ?`
      : `Are you sure you want to delete selected anchor point ${selectedAnchorPoints[0].anchorPointName}?`;
  const isAssignedAnchorPoint = selectedAnchorPoints.find((anchorPoint) => {
    return anchorPoint.routeAssigned;
  });
  return (
    <Dialog
      open={true}
      aria-labelledby="DeleteAnchorPoint-title"
      classes={{ paper: classes.dialog }}
      maxWidth="sm"
      onClose={props.onCancel}
    >
      <DialogTitle
        id="DeleteAnchorPoint-title"
        classes={{ root: classes.dialogTitlestyle }}
        disableTypography
        onClose={props.onCancel}
      >
        <Grid container item lg={12} md={12} xs={12}>
          <Grid item md={11} xs={10}>
            <span className={classes.dialogTitle}>Delete Anchor Point</span>
          </Grid>
          <Grid item md={1} xs={2} className={classes.closeIcon}>
            {props.onCancel ? (
              <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={props.onCancel}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        <Grid container spacing={24}>
          <Grid item xs={12} classes={{ root: classes.message }}>
            {isAssignedAnchorPoint
              ? "Please unassign anchor point from route before deleting."
              : errorMessage}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogAction }}>
        <Grid container spacing={24}>
          <Grid item xs={4}></Grid>
          <Grid item xs={8} classes={{ item: classes.actionButton }}>
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              className={classes.button}
              onClick={props.onCancel}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              size="small"
              disabled={isAssignedAnchorPoint}
              className={classes.redButton}
              onClick={() => {
                props.onConfirm();
                props.onCancel();
              }}
            >
              Confirm
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(DeleteAnchorPoint);
